import React, { useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { sendOrderToServer } from '../../react-components/sale-form/subcomponents/saleFormFunctions'
import { ErrorMessage, Form, Formik } from 'formik'
import { TextField } from '../../react-components/sale-form/subcomponents/textField'
import Switch from '../../react-components/sale-form/subcomponents/switchField'
import { freeLiveMeetingValidation } from '../subComponents/freeLiveMeetingValidation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FormErrorComponent } from '../../react-components/sale-form/subcomponents/formErrorComponent'
import ReactGA from 'react-ga'
import { PhoneField } from '../../react-components/sale-form/subcomponents/phoneField'
import { NipField } from '../../react-components/sale-form/subcomponents/nipField'
import { GoogleRecaptchaV3, handleCaptchaVerify } from '../../googleRecaptchaV3'
import { __, _x } from '@wordpress/i18n'
import { createInterpolateElement } from '@wordpress/element'

export const FlmForm = (props) => {
  const { gaID,activeRecord, setShowThankYou, setActiveRecord, data, acf_options } = props
  const [isError, setIsError] = useState(false)
  const [refreshCaptcha , setRefreshCaptcha] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const sourceParam = params.get('source');
  const rodoUrl  = _x('/polityka-prywatnosci', 'Link do rodo', 'strefamanagera');

  function handleFormSubmitError(error, data){
    if(data){
      setIsError({error_name:error, error_data:data});
    }else{
      setIsError(true);
    }
  }

  function sendActionToGA(){
    if(gaID!=='') {
      ReactGA.initialize(gaID);
      ReactGA.event({
        category: 'Free-Live-Meeting',
        action: 'USER REGISTERED',
        label: data.meeting.title
      });
    }
  }

  return (
    <div id={'form_' + data.meeting.id} className={'flm-form-container'}>
      <Row>
        <Col lg={8} md={8} sm={12}>
          <div className={'flm-from'}>
            <div className={'close-btn-wrapper'}>
              <div className={'close-btn'} onClick={() => {
                if (document.querySelector('#event_' + activeRecord)) {
                  document.querySelector('#event_' + activeRecord).scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'start'
                  })
                }
                setActiveRecord(false)
              }}>
                X
              </div>
            </div>
            {isError ? null : (<h4>{__('Zapisz się', 'strefamanagera')}</h4>)}

            <Formik
              initialValues={{
                orderByOrganization: true,
                termin: data.meeting.id.toString(),
                google_recaptcha_v3_token:'',
                nip: '',
                organization_name: '',
                orderUser_firstName: '',
                orderUser_lastName: '',
                orderUser_email: '',
                orderUser_phone: '',
                order_notes:'',
                source:sourceParam || 'direct',
                agreements: [
                  {
                    rodo: false,
                  },
                ],
              }}
              validationSchema={freeLiveMeetingValidation}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true)
                sendOrderToServer(values)
                  .then((res) => {
                    if(res.data.code === 200) {
                      sendActionToGA();
                      setSubmitting(false);
                      setShowThankYou(true);
                    }
                    else{
                      setSubmitting(false);
                      handleFormSubmitError('api' ,res.data);
                    }

                  })
                  .catch((err) => {
                    setSubmitting(false);
                    handleFormSubmitError('catch',err);
                  })
              }
              }

            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setSubmitting,
                isSubmitting,
                setFieldValue,
                /* and other goodies */
              }) => (
                <Form onSubmit={handleSubmit}>
                  {isError ? (
                    <FormErrorComponent acf_options={acf_options} error={isError} setIsError={setIsError} setRefreshCaptcha={setRefreshCaptcha}/>
                  ) : (
                    <React.Fragment>
                      {/*<div className="btn-group organization-switch" role="group">*/}
                      {/*  <Button className={values.orderByOrganization ? 'btn-switch active' : 'btn-switch '}*/}
                      {/*          onClick={() => {setFieldValue('orderByOrganization', true)}}>Firma</Button>*/}
                      {/*  <Button className={!values.orderByOrganization ? 'btn-switch active' : 'btn-switch '}*/}
                      {/*          onClick={() => {setFieldValue('orderByOrganization', false)}}> Osoba*/}
                      {/*    fizyczna</Button>*/}
                      {/*</div>*/}

                      <Row>
                        <Col className={'fieldCol'} xl={6} md={6} sm={6}>
                          <TextField name={`orderUser_firstName`} placeholder={__('Imię', 'strefamanagera')}/>
                        </Col>
                        <Col className={'fieldCol'} xl={6} md={6} sm={6}>
                          <TextField name={`orderUser_lastName`} placeholder={__('Nazwisko', 'strefamanagera')}/>
                        </Col>
                        <Col className={'fieldCol'} xl={6} md={6} sm={6}>
                          <TextField name={`orderUser_email`} placeholder={__('E-mail', 'strefamanagera')} type={'email'}/>
                        </Col>
                        <Col className={'fieldCol'} xl={6} md={6} sm={6}>
                          <PhoneField name={`orderUser_phone`} placeholder={__('Numer telefonu', 'strefamanagera')}/>
                        </Col>
                      </Row>


                      {values.orderByOrganization ? (
                        <Row>
                          <Col className={'fieldCol'} xl={6} md={6} sm={6}>
                            <TextField type={'text'} placeholder={__('Nazwa firmy', 'strefamanagera')} id="organization_name"
                                       name="organization_name"/>
                          </Col>
                          <Col className={'fieldCol'} xl={6} md={6} sm={6}>
                            <NipField type={'text'} placeholder={__('NIP', 'strefamanagera')} id="nip" name="nip" handleChange={handleChange} setFieldValue={setFieldValue}/>
                          </Col>
                        </Row>
                      ) : null}
                      <Switch className={'rodo-switch'} name={'agreements[0].rodo'} id={'rodo'}
                              label={__('Wyrażam zgodę na przetwarzanie moich danych dla potrzeb obsługi zgłoszenia na Live Meeting oraz w celach marketingowych.', 'strefamanagera')}
                              value={values.agreements[0].rodo} setFieldValue={setFieldValue}/>
                      <ErrorMessage
                        name={'agreements[0].rodo'}
                        component="div"
                        className="field-error"
                      />
                      <p className={'rodo'}>
                        {createInterpolateElement(
                          __('Administratorem Twoich danych osobowych jest IQ3 Górski, Fiedorowicz sp. j. <a>Kliknij i dowiedz się więcej</a> w tym o celach przetwarzania i o Twoich prawach.', 'strefamanagera'), {
                            a: <a className={'link'} href={rodoUrl} target={'_blank'}></a>,
                          }
                        )}
                      </p>
                      <p className={'info'}>
                        {__('Po wypełnieniu formularza otrzymasz link dostępowy do wydarzenia', 'strefamanagera')}
                      </p>
                      <div className={isSubmitting ? 'assign-button-disabled' : 'assign-button form-submit'}>
                        <Button size={'lg'} type={'submit'}>
                          {isSubmitting ? (
                            <React.Fragment>
                              <FontAwesomeIcon icon={faSpinner} pulse/> {__('Przetwarzanie', 'strefamanagera')}
                            </React.Fragment>
                          ) : (__('Zapisz się', 'strefamanagera'))}
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                  <GoogleRecaptchaV3 fieldName={'google_recaptcha_v3_token'} setFieldValue={setFieldValue} refreshCaptcha={refreshCaptcha} setRefreshCaptcha={setRefreshCaptcha}/>
                </Form>
              )}
            </Formik>
          </div>
        </Col>
        <Col lg={4} md={4} sm={12}>
          <div className={'flm-details-widget'}>
            <Row>
              <Col className={'training-duration'}>
                <p><i className="fa-solid fa-clock"></i>{__('Czas trwania:', 'strefamanagera')}</p>
                <p id="termin-time">{data.meeting.start_hour}-{data.meeting.end_hour}</p>  {/* TODO DANE*/}
              </Col>
              <Col className={'training-formula'}>
                <p><i className="fa-solid fa-wifi"></i>{__('Formuła:', 'strefamanagera')}</p>
                <p>{__('Online', 'strefamanagera')}</p>
              </Col>
              <Col xl={12} lg={12} md={12} sm={12}>
                <div className={'training-limits'}>
                  <p>
                    <i className="fa-solid fa-play"></i> {__('Live Meeting', 'strefamanagera')}
                  </p>
                </div>
              </Col>
            </Row>

          </div>
        </Col>
      </Row>
    </div>
  )
}